/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 * @generated-id: a8abf23f07f1
 */

import * as z from "zod";

/**
 * Request parameters for deleting derived resources
 */
export type DerivedDestroyRequest = {
  derived_resource_ids: Array<string>;
  invalidate?: boolean | undefined;
};

export const DerivedDestroyRequest$zodSchema: z.ZodType<DerivedDestroyRequest> =
  z.object({
    derived_resource_ids: z.array(z.string()).describe(
      "Array of derived resource IDs to delete specific derived resources",
    ),
    invalidate: z.boolean().optional().describe(
      "Whether to invalidate the CDN cache for the deleted resources",
    ),
  }).describe("Request parameters for deleting derived resources");
